module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/bnr_300_100-63f430b1e81401edcdb221888bac3c07.png";